import useUsersAccessRightStore from '@/stores/users/accessRight';

const teamFeatures = new Set([
  'invite-users', 'subprojects', 'selection',
  'integrations', 'integrations-in-element', 'webcalendar',
  'projectsheet-export',
  '/analysis/progress', '/analysis/planningusers', '/analysis/actions', '/analysis/portfolio',
]);

const businessFeatures = new Set([
  'business-config', 'business-tools', 'import-csv', 'recurrence', 'auto-optimize-dependencies',
  'projectsheet-moveblocks',
  '/analysis/personalcalendar',
]);

const enterpriseFeatures = new Set(['automations', 'risks', 'subprojects-manager']);

function hasAccessToPremiumFeature(feature) {
  const usersAccessRightStore = useUsersAccessRightStore();

  if (teamFeatures.has(feature)) return usersAccessRightStore.isPremium;
  if (businessFeatures.has(feature)) return usersAccessRightStore.isBusiness;
  if (enterpriseFeatures.has(feature)) return usersAccessRightStore.isEnterprise && usersAccessRightStore.isBusiness;
  if (feature == 'groups') return usersAccessRightStore.hasGroups;
  if (feature == 'macro') return usersAccessRightStore.hasMacroTasks;
  if (feature == 'import-template') return usersAccessRightStore.hasImportTemplate;
  if (feature == '/dashboards/monitoringplan') return usersAccessRightStore.hasMonitoringPlan;
  return false;
}

function getPremiumFeaturePack(feature) {
  if (teamFeatures.has(feature)) return 'TEAM';
  if (businessFeatures.has(feature)) return 'BUSINESS';
  if (enterpriseFeatures.has(feature)) return 'ENTERPRISE';
  if (feature == 'groups') return 'BUSINESS';
  if (feature == 'macro') return 'BUSINESS';
  if (feature == 'import-template') return 'BUSINESS';
  if (feature == '/dashboards/monitoringplan') return 'ENTERPRISE';
  return '';
}

export { hasAccessToPremiumFeature, getPremiumFeaturePack };
